import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { formatPhoneNumber, parsePhone } from '@/lib/formatter';
import sharedMessages from '@/lib/shared-messages';

import {
  // isConfirmed,
  // isRightLengthPassword,
  required,
  phoneNumber,
  isCompanyName,
  isMeaningfulCompanyName,
  isDepartmentName,
  isPositionName,
  isRightEmailAddress,
  isNotFreeEmailDomain,
  hasNoComma,
} from '@/lib/rule';

export interface SignUpFormData {
  email: string;
  firstName: string;
  lastName: string;
  middleName: string;
  companyName: string;
  // password: string;
  // passwordComfirmation: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpForm',
  props: {
    isValidForm: { type: Boolean },
    email: null,
    phone: null,
    department: null,
    position: null,
    firstName: null,
    lastName: null,
    middleName: null,
    companyName: null
  },
  emits: ["update:isValidForm", "update:firstName", "update:lastName", "update:middleName", "update:companyName", "update:email", "update:phone", "update:department", "update:position"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:firstName', data: string): void;
  (e: 'update:lastName', data: string): void;
  (e: 'update:middleName', data: string): void;
  (e: 'update:companyName', data: string): void;
  (e: 'update:email', data: string): void;
  (e: 'update:phone', data: string): void;
  (e: 'update:department', data: string): void;
  (e: 'update:position', data: string): void;
  // (e: 'update:password', data: string): void;
  // (e: 'update:passwordComfirmation', data: string): void;
}), expose: any, slots: any, attrs: any }) {





// const showPassword = ref(false);
// const showPasswordConfirmation = ref(false);
// const passwordComfirmation = ref('');

const formRef = ref(null);

const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateFirstName = (e: string) => {
  emits('update:firstName', e);
};

const updateLastName = (e: string) => {
  emits('update:lastName', e);
};

const updateMiddleName = (e: string) => {
  emits('update:middleName', e);
};

const updateCompanyName = (e: string) => {
  emits('update:companyName', e);
};

const updateEmail = (e: string) => {
  emits('update:email', e);
};

// const updatePassword = (e: string) => {
//   emits('update:password', e);
// };

const updatePhone = (e: string) => {
  emits('update:phone', e);
};

const updateDepartment = (e: string) => {
  emits('update:department', e);
};

const updatePosition = (e: string) => {
  emits('update:position', e);
};

onMounted(() => {
  if (formRef.value) {
    formRef.value.validate();
  }
});

return { __sfc: true,emits, formRef, updateIsValidForm, updateFirstName, updateLastName, updateMiddleName, updateCompanyName, updateEmail, updatePhone, updateDepartment, updatePosition, formatPhoneNumber, parsePhone, sharedMessages, required, phoneNumber, isCompanyName, isMeaningfulCompanyName, isDepartmentName, isPositionName, isRightEmailAddress, isNotFreeEmailDomain, hasNoComma }
}

})